import {
  doPostCartItem,
  doFetchQuote,
  doFetchCartProducts,
  doFetchTotalAmt,
  doDeleteCartProduct,
  doPutCartItem,
  doFetchCoupon,
  doApplyDiscountCode,
  doRemoveDiscountCode,
  doFetchCartId,
  doPostGiftCartItem,
  doPutGiftCartItem,
  doPostConfiguredCartItem,
  doPutConfiguredCartItem,
  doFetchGiftMessage,
  doPostCraneConnectionCartItem,
  doQtyUpdateCartItem,
  doUpdateCCProductQuantity
} from "@/services/guest_cart.service";
import { doFetchByDesignProjectId } from "@/services/builder_session.service";
import {
  getProductOptionByType,
  isStrictNonZeroDecimal,
  listrakCartList,
  listrakCartListClear,
  snakeToCamel,
  mergeCartProducts
} from "@/services/util.service";
import { doFetchList } from "@/services/builder_session_item.service";
import { getField, updateField } from "vuex-map-fields";
import { getCookieByName, setCookieByName } from "@/services/auth";


const crGuestQuoteId = import.meta.env.VITE_GUEST_QUOTE_ID;

export const cartProduct = {
  namespaced: true,
  state: {
    cartDrawer: false,
    inProgress: false,
    fetchInProgress: false,
    cartProduct: [],
    cartProductList: [],
    productTotalAmt: [],
    productMedia: {},
    discountCode: null,
    errorMessage: null,
    cartProductsProgress: false,
    cartTotalAmtProgress: false,
    giftCartDetailsGuest: {
      senderNameGuest: "",
      senderEmailGuest: "",
      recipientNameGuest: "",
      recipientEmailGuest: "",
      senderMessageGuest: "",
      giftCardAmtGuest: ""
    },
    giftMessageData: {},
    isCouponLoading: false
  },
  getters: {
    getField
  },
  mutations: {
    updateField,

    inProgress(state, yesOrNo) {
      state.inProgress = yesOrNo;
    },
    cartProductsProgress(state, yesOrNo) {
      state.cartProductsProgress = yesOrNo;
    },
    cartTotalAmtProgress(state, yesOrNo) {
      state.cartTotalAmtProgress = yesOrNo;
    },
    setCartDrawer(state, yesOrNo) {
      state.cartDrawer = yesOrNo;
    },
    fetchInProgress(state, yesOrNo) {
      state.fetchInProgress = yesOrNo;
    },
    setCartProduct(state, product) {
      state.cartProduct = product;
    },
    setCartProductList(state, list) {
      state.cartProductList = list;
    },

    setListrakCartList(state) {
      listrakCartList(state.cartProductList);
    },
    setListrakCartListClear() {
      listrakCartListClear();
    },
    setProductAmt(state, amt) {
      state.productTotalAmt = amt;
    },
    setProductsMedia(state, media) {
      state.productMedia = media;
    },
    setCouponCode(state, code) {
      state.discountCode = code.toString();
    },
    setErrorMessage(state, err) {
      state.errorMessage = err;
    },
    setGiftMessageData(state, giftMessage) {
      ((state.giftCartDetailsGuest.senderNameGuest =
        giftMessage[0].productOption?.infoBuyRequest?.giftcardSenderName ??
        giftMessage[0]?.senderName),
        (state.giftCartDetailsGuest.senderEmailGuest =
          giftMessage[0]?.productOption?.infoBuyRequest?.giftcardSenderEmail ??
          giftMessage[0]?.senderEmail),
        (state.giftCartDetailsGuest.recipientNameGuest =
          giftMessage[0]?.productOption?.infoBuyRequest
            ?.giftcardRecipientName ?? giftMessage[0]?.recipientName),
        (state.giftCartDetailsGuest.recipientEmailGuest =
          giftMessage[0]?.productOption?.infoBuyRequest
            ?.giftcardRecipientEmail ?? giftMessage[0]?.recipientEmail),
        (state.giftCartDetailsGuest.senderMessageGuest =
          giftMessage[0]?.productOption?.infoBuyRequest?.giftcardMessage ??
          giftMessage[0]?.message)(
            (state.giftCartDetailsGuest.giftCardAmtGuest =
              giftMessage[0]?.productOption?.infoBuyRequest?.giftcardAmount ??
              (giftMessage[0]?.amount?.value).toString())
          ));
    },
    updateCartItem(state, { index, data }) {
      state.cartProductList[index] = {
        ...state.cartProductList[index],
        ...data
      };
    },
    isCouponLoading(state, yesOrNo) {
      state.isCouponLoading = yesOrNo;
    }
  },
  actions: {
    addToCart: async ({ commit, dispatch }, data) => {
      try {
        let cartProduct;
        commit("inProgress", true);
        let guestQuoteId = getCookieByName(crGuestQuoteId);
        if (!guestQuoteId) {
          const guestQuote = await doFetchQuote();
          setCookieByName(crGuestQuoteId, guestQuote);
          cartProduct = await doPostCartItem(
            data.sku,
            data.qty,
            data.ccid,
            data.price,
            data.personalizeDetails,
            guestQuote
          );
          if (cartProduct) {
            commit("setCartProduct", cartProduct);
            dispatch("cartProductList", guestQuote);
            // dispatch("productTotalAmt", guestQuote);
          }
        } else {
          cartProduct = await doPostCartItem(
            data.sku,
            data.qty,
            data.ccid,
            data.price,
            data.personalizeDetails,
            guestQuoteId
          );
          if (cartProduct) {
            commit("setCartProduct", cartProduct);
            dispatch("cartProductList", guestQuoteId);
            // dispatch("productTotalAmt", guestQuoteId);
          }
        }
        commit("inProgress", false);
        commit("setCartDrawer", true);
        return cartProduct;
      } catch (err) {
        commit("inProgress", false);
        throw err;
      }
    },
    addToConfiguredCart: async ({ commit, dispatch }, data) => {
      try {
        commit("inProgress", true);
        let cartProduct;
        let guestQuoteId = getCookieByName(crGuestQuoteId);
        if (!guestQuoteId) {
          const guestQuote = await doFetchQuote();
          setCookieByName(crGuestQuoteId, guestQuote);
          cartProduct = await doPostConfiguredCartItem(
            data.sku,
            data.qty,
            data.typeId,
            data.optionId,
            data.optionValue,
            guestQuote
          );
          if (cartProduct) {
            commit("setCartProduct", cartProduct);
            dispatch("cartProductList", guestQuote);
            // dispatch("productTotalAmt", guestQuote);
          }
        } else {
          cartProduct = await doPostConfiguredCartItem(
            data.sku,
            data.qty,
            data.typeId,
            data.optionId,
            data.optionValue,
            guestQuoteId
          );
          if (cartProduct) {
            commit("setCartProduct", cartProduct);
            dispatch("cartProductList", guestQuoteId);
            // dispatch("productTotalAmt", guestQuoteId);
          }
        }
        commit("inProgress", false);
        commit("setCartDrawer", true);
        return cartProduct;
      } catch (err) {
        commit("inProgress", false);
        throw err;
      }
    },
    addToGiftCart: async ({ commit, dispatch, state }, data) => {
      try {
        commit("inProgress", true);
        let cartProduct;
        let guestQuoteId = getCookieByName(crGuestQuoteId);
        if (!guestQuoteId) {
          const guestQuote = await doFetchQuote();
          setCookieByName(crGuestQuoteId, guestQuote);
          cartProduct = await doPostGiftCartItem(
            data,
            guestQuote,
            state.giftCartDetailsGuest
          );
          if (cartProduct) {
            commit("setCartProduct", cartProduct);
            dispatch("cartProductList", guestQuote);
            // dispatch("productTotalAmt", guestQuote);
          }
        } else {
          cartProduct = await doPostGiftCartItem(
            data,
            guestQuoteId,
            state.giftCartDetailsGuest
          );
          if (cartProduct) {
            commit("setCartProduct", cartProduct);
            dispatch("cartProductList", guestQuoteId);
            // dispatch("productTotalAmt", guestQuoteId);
          }
        }

        commit("inProgress", false);
        commit("setCartDrawer", true);
        return cartProduct;
      } catch (err) {
        commit("inProgress", false);
        throw err;
      }
    },
    addCraneConnectionProductToCart: async (
      { commit, dispatch },
      { sku, qty, price, enteredOptions }
    ) => {
      try {
        commit("inProgress", true);
        let cartProduct = null;
        let guestQuoteId = getCookieByName(crGuestQuoteId);
        if (!guestQuoteId) {
          const guestQuote = await doFetchQuote();
          setCookieByName(crGuestQuoteId, guestQuote);
          cartProduct = await doPostCraneConnectionCartItem({
            sku,
            qty,
            price,
            enteredOptions,
            guestQuoteId: guestQuote
          }); // builderId
          if (cartProduct) {
            commit("setCartProduct", cartProduct);
            dispatch("cartProductList", guestQuote);
            //  dispatch("productTotalAmt", guestQuote);
          }
        } else {
          cartProduct = await doPostCraneConnectionCartItem({
            sku,
            qty,
            price,
            enteredOptions,
            guestQuoteId
          }); // builderId
          if (cartProduct) {
            commit("setCartProduct", cartProduct);
            dispatch("cartProductList", guestQuoteId);
            //  dispatch("productTotalAmt", guestQuoteId);
          }
        }
        commit("inProgress", false);
        commit("setCartDrawer", true);
        return cartProduct;
      } catch (err) {
        commit("inProgress", false);
        throw err;
      }
    },
    productTotalAmt: async ({ commit }, guestQuoteId) => {
      commit("cartTotalAmtProgress", true);
      doFetchTotalAmt(guestQuoteId)
        .then((productTotalAmt) => {
          commit("cartTotalAmtProgress", false);
          commit("setProductAmt", snakeToCamel(productTotalAmt));
        })
        .catch(() => commit("cartTotalAmtProgress", false));
    },
    cartProductList: async ({ commit, state, dispatch }, guestQuoteId) => {
      try {
        commit("cartProductsProgress", true);

        const cartData = await doFetchCartProducts(guestQuoteId);
        const totals = cartData.totals;

        // Step 1: merge old + new
        const newList = snakeToCamel(cartData.items);
        let cartProductList = mergeCartProducts(state.cartProductList, newList);

        // Step 2: process items in parallel
        await Promise.all(
          cartProductList.map(async (item, i) => {
            if (
              item?.customizableOptions?.length &&
              !item.itemIds && !item.builderSessionItemList
            ) {
              const optionsList = item.customizableOptions;

              const builderSessionOne = optionsList.find(
                (x) => x.label === "BuilderSessionId"
              );

              const designProjectId = optionsList.find(
                (x) => x.label === "DESIGN_PROJECT_ID"
              );

              // 🔹 Builder Session Flow
              if (builderSessionOne) {
                const sessionId = builderSessionOne.values?.[0]?.value;

                if (sessionId) {
                  const sessionData = await doFetchList({ sessionId });

                  if (sessionData?.length) {
                    item.thumbnailUrl = sessionData.map(a => a.thumbnail_url); // API still snake_case
                    item.itemIds = sessionData.map(a => a.id);
                  }
                }
              }

              // 🔹 Design Project Flow
              else if (designProjectId) {
                const value = designProjectId.values?.[0]?.value;

                if (value) {
                  try {
                    const response = await doFetchByDesignProjectId({
                      designProjectId: value
                    });

                    const builderSession = snakeToCamel(response?.[0]);
                    if (!builderSession) return;

                    const items = builderSession.builderSessionItem || [];

                    if (builderSession.orderState === "prepare_svg") {
                      item.builderSessionItemList = items.map(x => ({
                        ...x,
                        thumbnailUrl: null
                      }));

                      dispatch("pollSessionData", {
                        designProjectId: value,
                        index: i
                      });
                    } else {
                      item.builderSessionItemList = items;
                    }

                  } catch (error) {
                    console.log("design fetch error", error);
                  }
                }
              }
            }
          })
        );

        // ✅ Single commit (correct)
        commit("setCartProductList", cartProductList);
        commit("setProductAmt", snakeToCamel(totals));
        commit("cartProductsProgress", false);
        commit("cartTotalAmtProgress", false);

        return cartProductList;

      } catch (err) {
        console.log("error in cart process", err);
        commit("setCartProductList", []);
        commit("cartProductsProgress", false);
        commit("cartTotalAmtProgress", false);
      }
    },
    removeCartProduct: async ({ commit, dispatch }, itemUid) => {
      let guestQuoteId = getCookieByName(crGuestQuoteId);
      try {
        commit("cartProductsProgress", true);
        commit("cartTotalAmtProgress", true);
        let trueOrFalse = await doDeleteCartProduct(itemUid, guestQuoteId);
        if (trueOrFalse) {
          commit("cartProductsProgress", false);
          commit("cartTotalAmtProgress", true);
          commit("setCartDrawer", false);
          await dispatch("cartProductList", guestQuoteId);
          //  dispatch("productTotalAmt", guestQuoteId);
          dispatch("setListrakCartListClear");
        }
      } catch (err) {
        commit("cartProductsProgress", false);
        commit("cartTotalAmtProgress", true);
        throw err;
      }
    },
    updateToCart: async ({ commit, dispatch }, data) => {
      let guestQuoteId = getCookieByName(crGuestQuoteId);
      try {
        commit("cartProductsProgress", true);
        const cartProduct = await doPutCartItem(
          data.sku,
          data.qty,
          guestQuoteId,
          data.itemId,
          data.ccid,
          data.price,
          data.personalizeDetails,
          data.optionId,
          data.optionValue
        );
        if (cartProduct) {
          commit("cartProductsProgress", false);
          if (data.routeName != "CartProducts") {
            commit("setCartDrawer", true);
          }
          commit("setCartProduct", cartProduct);
          dispatch("cartProductList", guestQuoteId);

          return cartProduct;
        }
      } catch (err) {
        commit("cartProductsProgress", false);
        dispatch("cartProductList", guestQuoteId);

        throw err;
      }
    },
    updateQtyToCart: async ({ commit, dispatch }, data) => {
      let guestQuoteId = getCookieByName(crGuestQuoteId);
      try {
        commit("cartProductsProgress", true);
        const cartProduct = await doQtyUpdateCartItem({
          qty: data.qty,
          quoteId: guestQuoteId,
          itemId: data.itemId,
          enteredOptions: []
        });
        if (cartProduct) {
          commit("cartProductsProgress", false);
          if (data.routeName != "CartProducts") {
            commit("setCartDrawer", true);
          }
          commit("setCartProduct", cartProduct);
          dispatch("cartProductList", guestQuoteId);
          //dispatch("productTotalAmt", guestQuoteId);
          return cartProduct;
        }
      } catch (err) {
        commit("cartProductsProgress", false);
        dispatch("cartProductList", guestQuoteId);
        // dispatch("productTotalAmt", guestQuoteId);
        throw err;
      }
    },
    updateToPersonalizeCartItem: async (
      { commit, dispatch },
      {
        qty,
        itemId,
        perosonalizeIdValue,
        orderTotal = null,
        productOptions,
        byType,
        optionIdType,
        routeName = null,
        updateToCC = false,
        perosonalizeId = null
      }
    ) => {
      try {
        let guestQuoteId = getCookieByName(crGuestQuoteId);

        // Fetch guest quote only if not exists
        if (!guestQuoteId) {
          guestQuoteId = await doFetchQuote();
          setCookieByName(crGuestQuoteId, guestQuoteId);
        }

        // Update Crane Connection order quantity
        let totalPrice = "" + orderTotal;
        if (updateToCC) {
          let responseData = await doUpdateCCProductQuantity({
            orderNumber: perosonalizeIdValue,
            quantity: qty
          });
          const match = responseData.data.match(/price\s+is:\s*(\d+)/i);
          const price = match ? Number(match[1]) : null;
          totalPrice = "" + price;
        }

        if (!isStrictNonZeroDecimal(totalPrice)) {
          throw "Error in updating cart quntity, please try again later.";
        }

        if (!perosonalizeId) {
          throw "Error in updating cart quntity, please try again later.";
        }
        const customOptions = [
          { name: perosonalizeId, value: perosonalizeIdValue },
          { name: "custom_price", value: totalPrice }
        ];

        const customizableOptions = getProductOptionByType({
          productOptions,
          customOptions,
          action: "update",
          optionIdType: optionIdType,
          byType: byType
        });

        // Update cart item quantity
        const cartProduct = await doQtyUpdateCartItem({
          qty: qty,
          quoteId: guestQuoteId,
          itemId: itemId,
          customizableOptions: customizableOptions
        });

        if (!cartProduct) return null;

        // UI updates
        if (routeName !== "CartProducts") {
          commit("setCartDrawer", true);
        }

        commit("setCartProduct", cartProduct);

        // Refresh cart state
        await Promise.all([
          dispatch("cartProductList", guestQuoteId)
          //  dispatch("productTotalAmt", guestQuoteId),
        ]);

        return cartProduct;
      } catch (err) {
        console.error("updateToCraneConectionCart failed:", err);
        throw err;
      }
    },
    updateToConfiguredCart: async ({ commit, dispatch }, data) => {
      let guestQuoteId = getCookieByName(crGuestQuoteId);
      try {
        commit("cartProductsProgress", true);
        const cartProduct = await doPutConfiguredCartItem(
          data.sku,
          data.qty,
          guestQuoteId,
          data.itemId,
          data.optionId,
          data.optionValue
        );
        if (cartProduct) {
          commit("cartProductsProgress", false);
          if (data.routeName != "CartProducts") {
            commit("setCartDrawer", true);
          }
          commit("setCartProduct", cartProduct);
          dispatch("cartProductList", guestQuoteId);
          // dispatch("productTotalAmt", guestQuoteId);
          return cartProduct;
        }
      } catch (err) {
        dispatch("cartProductList", guestQuoteId);
        // dispatch("productTotalAmt", guestQuoteId);
        commit("cartProductsProgress", false);
        throw err;
      }
    },
    updateToGiftCart: async ({ commit, dispatch, state }, data) => {
      let guestQuoteId = getCookieByName(crGuestQuoteId);

      try {
        commit("inProgress", true);
        const cartProduct = await doPutGiftCartItem(
          data,
          guestQuoteId,
          state.giftCartDetailsGuest
        );
        if (cartProduct) {
          commit("inProgress", false);
          if (data.routeName != "CartProducts") {
            commit("setCartDrawer", true);
          }
          commit("setCartProduct", cartProduct);
          dispatch("cartProductList", guestQuoteId);
          //  dispatch("productTotalAmt", guestQuoteId);
          return cartProduct;
        }
      } catch (err) {
        dispatch("cartProductList", guestQuoteId);
        // dispatch("productTotalAmt", guestQuoteId);
        commit("inProgress", false);
        throw err;
      }
    },
    cartDrawer: async ({ commit }, flag) => {
      commit("setCartDrawer", flag);
    },
    fetchCartCoupon: async ({ commit }, guestQuoteId) => {
      commit("isCouponLoading", true);
      commit("cartTotalAmtProgress", true);
      try {
        let coupon = await doFetchCoupon(guestQuoteId);
        if (coupon) {
          commit("setCouponCode", coupon);
        }
      } catch (err) {
        throw err;
      } finally {
        commit("isCouponLoading", false);
        commit("cartTotalAmtProgress", false);
      }
    },
    applyDiscountCode: async ({ commit, dispatch }, data) => {
      commit("isCouponLoading", true);
      commit("cartTotalAmtProgress", true);
      try {
        let coupon = await doApplyDiscountCode(
          data.discountTextCode,
          data.guestQuoteId
        );
        if (coupon) {
          dispatch("fetchCartCoupon", data.guestQuoteId);
        }
      } catch (err) {
        throw err;
      } finally {
        commit("isCouponLoading", false);
        commit("cartTotalAmtProgress", false);
      }
    },
    removeDiscountCode: async ({ commit, dispatch }, data) => {
      commit("isCouponLoading", true);
      commit("cartTotalAmtProgress", true);
      try {
        let coupon = await doRemoveDiscountCode(data.guestQuoteId);
        if (coupon) {
          dispatch("fetchCartCoupon", data.guestQuoteId);
        }
      } catch (err) {
        throw err;
      } finally {
        commit("isCouponLoading", false);
        commit("cartTotalAmtProgress", false);
      }
    },
    fetchGiftMessage: async ({ commit }, data) => {
      let guestQuoteId = getCookieByName(crGuestQuoteId);
      commit("fetchInProgress", true);
      try {
        await doFetchCartId(guestQuoteId).then(async (cartProductDetails) => {
          const giftMessageData = await doFetchGiftMessage(
            cartProductDetails.id,
            data.itemId
          );
          if (giftMessageData) {
            console.log("giftMessageData", giftMessageData[0]?.amount?.value);
            commit("fetchInProgress", false);
            commit("setGiftMessageData", snakeToCamel(giftMessageData));
          }
        });
      } catch (err) {
        commit("fetchInProgress", false);
        throw err;
      }
    },

    setListrakCartList: async ({ commit, state }) => {
      if (state.cartProductList.length > 0) {
        commit("setListrakCartList");
      }
    },
    setListrakCartListClear: async ({ commit, state }) => {
      if (state.cartProductList.length <= 0) {
        commit("setListrakCartListClear");
      }
    },
    pollSessionData: async (
      { commit },
      { designProjectId, index, interval = 2000, maxTries = 20 }
    ) => {
      let tries = 0;

      const pollInterval = setInterval(async () => {
        try {
          tries++;
          let response = await doFetchByDesignProjectId({
            designProjectId
          });
          let builderSession = response.length > 0 ? response[0] : null;
          console.log("builderSession order state", builderSession.order_state);
          if (builderSession.order_state !== "prepare_svg") {
            console.log(
              "builderSession order state changed",
              builderSession.order_state
            );
            clearInterval(pollInterval);
            if (
              builderSession &&
              builderSession.builder_session_item.length > 0
            ) {
              let builderSessionItemList =
                builderSession.builder_session_item.map((item) => ({
                  ...item,
                  thumbnailUrl: item.thumbnail_url
                }));

              commit("updateCartItem", {
                index: index,
                data: { builderSessionItemList: builderSessionItemList }
              });
            }
          } else if (tries >= maxTries) {
            console.warn(
              "Session data not found after 10 tries, stopping poll."
            );
            clearInterval(pollInterval);
          }
        } catch (err) {
          console.error("Error polling session data:", err);
          clearInterval(pollInterval);
        }
      }, interval);

      return pollInterval; // so you can clear it manually if needed
    },
    cartTotalAmtProgress({ commit }, yesOrNo) {
      commit("cartTotalAmtProgress", yesOrNo);
    },
    updateQuoteId: async ({ commit }) => {
      try {
        const guestQuote = await doFetchQuote();
        setCookieByName(crGuestQuoteId, guestQuote);
      } catch (error) {
        commit("errorMessage", error.message);
      }
    }
  }
};
